'use client'

import { IMapMethods, type IResponseGetRoute, type ITravelPointQuote } from '@repo/sdk'
import { useRef, useState } from 'react'

import { MapContextProvider } from './context.tsx'
import { DarkMap } from './dark-map.tsx'
import { useMap } from './use-map.ts'

interface IProps {
  drops: ITravelPointQuote[]
  getRoute: (routes: string[]) => Promise<IResponseGetRoute | void>
}

export const DarkMapEasy = ({ drops, getRoute }: IProps) => {
  const [isLoading, setIsLoading] = useState(true)

  const refMap = useRef<IMapMethods>(undefined)

  useMap(drops, refMap, isLoading)

  return (
    <MapContextProvider getRoute={getRoute} isLoading setIsLoading={setIsLoading}>
      <div className="flex h-full w-full flex-col items-center justify-center">
        <DarkMap ref={refMap} />
      </div>
    </MapContextProvider>
  )
}
